var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28101 12.8407C9.01701 12.8407 10.281 11.2567 10.697 10.7287C10.953 10.4087 10.9049 9.9287 10.569 9.6887C10.441 9.5767 10.281 9.5287 10.1049 9.5287C9.88101 9.5287 9.65701 9.6247 9.51301 9.8167C8.93701 10.5367 8.05701 11.3687 6.28101 11.3687C3.80101 11.3687 1.78485 9.3527 1.78485 6.8727C1.78485 4.3927 3.80101 2.3767 6.28101 2.3767C8.07301 2.3767 8.95301 3.2087 9.51301 3.9287C9.76901 4.2487 10.233 4.3127 10.569 4.0567C10.889 3.8007 10.953 3.3367 10.697 3.0007C10.281 2.4727 9.01701 0.888699 6.28101 0.888699C2.98485 0.888699 0.297014 3.5767 0.297014 6.8727C0.297014 10.1687 2.98485 12.8407 6.28101 12.8407Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3047 6.12076L5.89671 6.12076C5.48087 6.12076 5.14471 6.45676 5.14471 6.87276C5.14471 7.28876 5.48087 7.62476 5.89671 7.62476L13.2887 7.62476L12.2327 8.68076C12.0887 8.82476 12.0087 9.01676 12.0087 9.20876C12.0087 9.40076 12.0887 9.59276 12.2327 9.73676C12.5207 10.0248 13.0007 10.0248 13.2887 9.73676L15.6087 7.38476C15.8967 7.09676 15.8967 6.61676 15.6087 6.32876L13.2887 3.97676C13.1447 3.83276 12.9527 3.75276 12.7607 3.75276C12.5687 3.75276 12.3767 3.83276 12.2327 3.96076C12.0887 4.1046 12.0087 4.28076 12.0087 4.48876C12.0087 4.68076 12.0887 4.87276 12.2167 5.01676L13.3047 6.12076Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1e06005dd7f95ce13b867475ca3c1b82.svg";
export { ForwardRef as ReactComponent };